<template>
  <div class="card modal-card">
    <div class="modal-card-body pd-0">
      <header class="bandeau-modal card-header">
      </header>
      <div class="card-content" v-if="demarcheur">
        <p class="title has-text-centered mgb-20px">
          {{ $t('ajoutEditContrat.demarcheur.addDemarcheur')}}
        </p>
        <error-msg-component
          :messages="messagesErreur"
          :error="error"
          :messagesChampsVide="messagesChampsVide"
          :champsVide="champsVide"
          title="general.problemOccurred"
          @close="error = $event"/>
        <b-field
          :label="$t('ajoutEditContrat.demarcheur.raisonSociale')"
          :type="typeNomCommercial"
          class="obligatoire">
          <b-input v-model="demarcheur.nomCommercial"></b-input>
        </b-field>
        <p class="mgt-20px is-italic has-text-icon-more is-size-5">
          {{$t('ajoutEditContrat.demarcheur.adresse')}}
        </p>
        <b-field :label="$t('ajoutEditContrat.demarcheur.adressePostale')">
          <app-adresse :showLibelle="false"
            :adresse="demarcheur.adressePostale"
            :tableName="TIERS"/>
        </b-field>
        <b-field :label="$t('ajoutEditContrat.demarcheur.compteComptable')">
          <b-input v-model="demarcheur.compteComptable"></b-input>
        </b-field>
        <b-field class="mgt-10px">
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close">
              {{ $t('general.button.return')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="creerDemarcheur()">
              {{ $t('general.button.add')}}
            </a>
          </div>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import Adresse from '@/components/general/adresse';
import gestionType from '@/services/general/gestionType';
import genererDemarcheur from '@/services/tiers/genererTiers';
import { insertTiers } from '@/services/tiers/saveTiers';
import validation from '@/services/tiers/validationTiers';
import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { TIERS_SOUS_TYPE_DEMARCHEUR, TIERS_TYPE_FOURNISSEUR } from '@/configuration/tiers/tiersConf';
import { TIERS } from '@/configuration/ville/villeConf';
import validationGeneral from '@/services/validation/validation';
import champsTiersTranslator from '@/services/tiers/champsTiersTranslator';

const societe = createNamespacedHelpers('societe');

export default {
  props: {
    nomDemarcheur: {
      type: String,
      required: true,
    },
  },
  components: {
    appAdresse: Adresse,
    errorMsgComponent,
  },
  data() {
    return {
      TIERS: TIERS,
      error: false,
      messagesErreur: [],
      champsVide: [],
      messagesChampsVide: [],
      demarcheur: genererDemarcheur(),
    };
  },
  computed: {
    typeNomCommercial() {
      return gestionType(this.demarcheur.nomCommercial, this.error);
    },
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  methods: {
    async creerDemarcheur() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.messagesErreur = [];
        this.error = false;
        this.messagesChampsVide = [];
        this.champsVide = [];
        this.demarcheur.societeId = this.societeActiveId;
        const demarcheur = await insertTiers(this.demarcheur);
        this.$emit('creationDone', demarcheur);
        this.error = false;
        this.$parent.close();
        messageSucces(this.$i18n.t('ajoutEditContrat.messages.success.successCreation'));
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messagesErreur, this.messagesChampsVide, champsTiersTranslator);
          validation(e.response, this.messagesErreur);
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
  },
  mounted() {
    this.demarcheur.nomCommercial = this.nomDemarcheur;
    this.demarcheur.type = TIERS_TYPE_FOURNISSEUR;
    this.demarcheur.sousTypes = [TIERS_SOUS_TYPE_DEMARCHEUR];
  },
};
</script>

<style>
</style>
